import { Event } from '@frontend/events/types';
import { ReactNode } from 'react';

import { getEventTypeLabel } from './map-event-data-to-display';

interface HistoryEventDetailsProps {
    event: Event;
    timestamp: ReactNode;
}

/** Renders event type and timestamp under a history timeline entry. */
export const HistoryEventDetails = (props: HistoryEventDetailsProps) => {
    return (
        <small className='text-sm antialiased'>
            <span className='text-brand-secondary font-weight-bold mt-1 mb-0 text-xs'>{getEventTypeLabel(props.event.type)}</span>
            <br />
            <span className='text-brand-secondary font-weight-bold mt-1 mb-0 text-xs'>{props.timestamp}</span>
        </small>
    );
};
